import { Form, FormItemProps, Select } from "antd";
import { Rule } from "antd/lib/form";
import { LabelTooltipType } from "antd/lib/form/FormItemLabel";
import { NamePath } from "antd/lib/form/interface";
import React from "react";
import { ResourceModel } from "../../../models/resources.model";
const { Option } = Select;

interface Props extends FormItemProps {
    disabled?: boolean;
    placeholder?: string;
    list: ResourceModel[] | undefined;
    name: NamePath;
    label?: React.ReactNode;
    className?: string;
    tooltip?: LabelTooltipType;
    onChange?: (value: number) => void;
    rules?: Rule[];
}

interface ChildrenSelectProps extends Props {
    parentName: string;
    listFilterName: string;
}


export const AppChildrenSelect = (props: ChildrenSelectProps) => {
    const {
        name,
        placeholder,
        parentName,
        list,
        listFilterName,
        label,
        tooltip,
        className,
        rules } = props;

    const getParentValue = (value: any) => {
        const array = parentName.split(".");
        if (array.length <= 1) {
            return value[parentName];
        }
        for (let index = 0; index < array.length; index++) {
            const item = array[index];
            if (item.indexOf("[") >= 0) {
                const cIndex = item.indexOf("[");
                const item1 = item.substring(0, cIndex);
                const item2 = item.substring(cIndex + 1, item.length - 1);

                if (!value) {
                    return value;
                }
                value = value[item1];

                if (!value) {
                    return value;
                }

                const index = Number(item2);
                value = value[index];
            } else {
                value = value[item];
            }

            if (!value) {
                return value
            }
        }

        return value;
    }

    const renderSelect = (getFieldsValue: () => any) => {
        const parrentId = getParentValue(getFieldsValue());
        const newList = list?.filter(p => Object(p)[listFilterName] === parrentId);

        return (
            <Form.Item
                name={name}
                label={label}
                tooltip={tooltip}
                className={className}
                rules={rules}
            >
                <AppSelect
                    disabled={!parrentId}
                    placeholder={placeholder}
                    list={newList}
                    name={name} />
            </ Form.Item >
        )
    }

    return (
        <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) => {
                return getParentValue(prevValues) !== getParentValue(currentValues)
            }}
        >
            {({ getFieldsValue }) => renderSelect(getFieldsValue)}
        </ Form.Item>)
}


export const AppSelect = (props: Props) => {

    return (
        <Form.Item
            name={props.name}
            label={props.label}
            tooltip={props.tooltip}
            className={props.className}
            rules={props.rules}
        >
            <Select
                onChange={props.onChange}
                disabled={props.disabled}
                showSearch
                placeholder={props.placeholder}
                filterOption={(input, option) => (option?.children as unknown as string)?.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                allowClear >
                {props.list && props.list.map((item, index) => (
                    <Option key={index} value={item.id}>{item.name}</Option>
                ))}
            </Select>
        </Form.Item>)
}
